import React from "react";
import styled from "styled-components";
interface OwnProps {
	description: string;
}
export const RootNodeDescription = ({ description }: OwnProps) => {
	return (
		<div className="flex align-items-center justify-content-center mt-2">
			{description ? <Description dangerouslySetInnerHTML={{ __html: description }} /> : null}
		</div>
	);
};

const Description = styled.div`
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.96px;
	margin-bottom: 24px;
	word-break: break-word;
	hyphens: auto;
`;
